import React from 'react'

import ReactWhatsapp from "react-whatsapp";
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";


import BraceletLoha17_840gm from "../images/Bracelet Loha  17.840gm.jpg";
import BraceletLoha9_140gm from "../images/Bracelet Loha  9.140gm.jpg";
import BraceletLoha10_720gm from "../images/Bracelet Loha  10.720gm.jpg";
import BraceletLoha9_510gm from "../images/Bracelet Loha 9.510gm.jpg";

import BraceletLoha18_380gm from "../images/Bracelet Loha  18.380gm.jpg";
import BraceletLoha16_540gm from "../images/Bracelet Loha 16.540gm.jpg";
import BraceletLoha16_00gm from "../images/Bracelet Loha  16.00gm.jpg";
import BraceletLoha9_150gm from "../images/Bracelet9.150gm_new.jpg"


import BraceletLoha9_280gm from "../images/Bracelet Loha 9.280gm.jpg";
import BraceletLoha9_620gm from "../images/Bracelet Loha 9.620gm.jpg";
import BraceletLoha10_040gm from "../images/Bracelet Loha 10.040gm.jpg";
import BraceletLoha10_120gm from "../images/Bracelet Loha 10.120gm.jpg";





import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import Header  from '../inc/Header';





function BraceletLoha() {
    return (
        <div>
<Header/>
<br/>
<br/>
<br/>
<br/>
 <ScrollToTop smooth top="100" color="maroon" />
                    <div className='colorbacklockt'>
                        <div className="album py-1">
                            <div className="container mt-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Bracelet Loha</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={BraceletLoha17_840gm} className="card-img-top" alt="BraceletLoha17.840gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 17.840gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha9_140gm} className="card-img-top" alt="BraceletLoha9.140gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 9.140gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha10_720gm} className="card-img-top" alt="BraceletLoha9.140gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 10.720gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha9_510gm} className="card-img-top" alt="BraceletLoha9_510gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Bracelet Loha                                 </h5>
                                                <p className="card-text">Weight: 9.510gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

           <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={BraceletLoha18_380gm} className="card-img-top" alt="BraceletLoha18.380gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 18.380gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha16_540gm} className="card-img-top" alt="BraceletLoha16.540gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 16.540gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha16_00gm} className="card-img-top" alt="Bracelet Loha16.00gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 16.00gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha9_150gm} className="card-img-top" alt="BraceletLoha9_150gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Bracelet Loha                                 </h5>
                                                <p className="card-text">Weight: 9.150gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


   <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={BraceletLoha9_280gm} className="card-img-top" alt="BraceletLoha9.280gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 9.280gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha9_620gm} className="card-img-top" alt="BraceletLoha9.620gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 9.620gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha10_040gm} className="card-img-top" alt="Bracelet Loha10.040gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Bracelet Loha </h5>
                                                <p className="card-text">Weight: 10.040gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BraceletLoha10_120gm} className="card-img-top" alt="BraceletLoha10_120gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Bracelet Loha                                 </h5>
                                                <p className="card-text">Weight: 10.120gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <br />
        </div>
    )
}

export default BraceletLoha